"use client";

import { useLocale, useTranslations } from "use-intl";

import { ReleaseIcon } from "@/components/appIcons";
import { Link } from "@/components/link";
import type { DealOfferExplorerWorkRelease } from "@/components/marketplace/deal-offer-explorer-types";
import { formatCountry } from "@garimpa/lib/countries";

export function DealOfferEditionContext({
  releases,
}: {
  releases: DealOfferExplorerWorkRelease[];
}) {
  const locale = useLocale();
  const t = useTranslations("shared.affiliates");

  return (
    <div className="flex w-full min-w-0 flex-col gap-1 text-xs text-muted-foreground">
      {releases.map((release) => {
        const details = [
          release.labelNames[0],
          release.date?.slice(0, 4),
          release.country ? formatCountry(release.country, locale) : null,
        ].filter(Boolean);

        return (
          <Link
            key={release.id}
            to="/release/$id"
            params={{ id: release.id }}
            className="pointer-events-auto relative z-20 flex min-h-11 w-full min-w-0 items-start gap-1 rounded-md px-1 py-1 transition-colors hover:bg-secondary hover:text-primary lg:min-h-7"
            title={[t("otherEdition"), ...details].join(" · ")}
          >
            <ReleaseIcon className="mt-0.5 shrink-0 text-sm" />
            <span className="min-w-0 whitespace-normal [overflow-wrap:anywhere]">
              <span className="font-semibold">{t("otherEdition")}</span>
              {details.length > 0 && <> · {details.join(" · ")}</>}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
